"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderBy = exports.CompatibleOrderByConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
class CompatibleOrderByConfig {
    constructor(config) {
        this.config = config;
        this.operation = 'orderBy';
        // Private instance properties allow typescript to ensure that an instance of
        // this class is being used.
        this.isCompatible = true;
        this.ensureCompatibility = (loanTape) => {
            const { field, type } = this.config;
            if ((0, utils_1.isCalcPropertyKey)(field)) {
                (0, common_1.finleyAssert)(type === 'number', `Invalid type ${type} for field ${field}`);
                return;
            }
            const invalidRecord = lodash_1.default.find(loanTape, (record) => {
                const value = (0, utils_1.getFieldValue)({ loanTape: record, field });
                return !lodash_1.default.isNil(value) && typeof value !== type;
            });
            (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({ invalidRecord, field, type }));
            (0, common_1.finleyAssert)(this.isCompatible, 'Config must be compatible with loanTape');
        };
        this.config = config;
    }
}
exports.CompatibleOrderByConfig = CompatibleOrderByConfig;
CompatibleOrderByConfig.create = (config, loanTape) => {
    const obj = new CompatibleOrderByConfig(config);
    obj.ensureCompatibility(loanTape);
    return obj;
};
const comparableField = ({ field }) => (loanTape) => {
    const value = (0, utils_1.getFieldValue)({
        field,
        loanTape,
    });
    return lodash_1.default.toNumber(value);
};
const fieldIsNotNil = ({ field }) => (loanTape) => !lodash_1.default.isNil((0, utils_1.getFieldValue)({ loanTape, field }));
/*
 * Orders all loan tapes by the value of a field or calc property
 * then selects the first N loanTapes. Calc properties are
 * the calculated values that are used in each step of the
 * borrowing base report generation.
 *
 * example config:
 * {
 *    field: 'borrowingBaseAmount',
 *    operation: 'orderBy'
 *    count: 1,
 *    type: 'number',
 * }
 *
 */
const orderBy = ({ config: { field, order = 'desc', count }, }) => (loanTapeRecords) => (0, remeda_1.pipe)(loanTapeRecords, 
// Selecting loanTapes where the field value is undefined or null is not supported.
// it's unclear whether undefined or null should be sorted at the end with 0 and 'a'
// values or not, so we filter them out instead
(0, remeda_1.filter)(fieldIsNotNil({ field })), (0, remeda_1.sortBy)([
    comparableField({ field }),
    order,
]), (0, remeda_1.take)(count));
exports.orderBy = orderBy;
//# sourceMappingURL=orderBy.js.map